import styled from 'styled-components'

import Label from '~/truck/label'

export const StyledLeftItemInput = styled(Label)`
  left: ${props => props.theme.spacing.relaxed}px;
  position: absolute;
  transform: translateX(-50%);
`
